/**
 * Hands `api.ts` a way to get a token, without `api.ts` knowing about React.
 *
 * Renders nothing. It registers a *function*, not a token, and that function calls
 * `getToken()` afresh on every invocation — the session token lives 60 seconds, so a
 * token captured at mount would be dead long before the user picks a file. Clerk keeps
 * its own short-lived cache behind `getToken()` and refreshes as expiry approaches; that
 * is the only cache in the path, and it is the one that knows when to give up.
 *
 * The portal's `ClerkProvider` supplies `useAuth`, and every document-reader route sits
 * under `_protected`, so the user is always signed in by the time this mounts.
 */

import { useAuth } from '@clerk/clerk-react';
import { useEffect } from 'react';
import { setTokenProvider } from './api';

export function TokenBridge() {
	const { getToken } = useAuth();

	useEffect(() => {
		setTokenProvider(() => getToken());
		return () => setTokenProvider(null);
	}, [getToken]);

	return null;
}
